import * as React from "react"

function TouchIcon({...props}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}>
      <rect width={28} height={44} x={4} y={2} fill="#bec6c6" rx={3} />
      <path fill="#f8f9f9" d="M7 5h22v38H7z" />
      <circle cx={18} cy={19} r={8} fill="#bec6c6" />
      <circle cx={18} cy={19} r={5} fill="#6457ff" />
      <path
        fill="#414141"
        d="M29 47H7a4 4 0 0 1-4-4V5a4 4 0 0 1 4-4h22a4 4 0 0 1 4 4v38a4 4 0 0 1-4 4ZM7 3a2 2 0 0 0-2 2v38a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"
      />
      <path fill="#bec6c6" d="M21 7h-6a2 2 0 0 1-2-2h10a2 2 0 0 1-2 2Z" />
      <path
        fill="#f8f9f9"
        d="m37.73 24.14 4.9 8.48a4.07 4.07 0 0 1 .53 2.26c-.15 2.3-.2 2.31 0 2.65L44 39l-12.12 7-1.18-2a2.06 2.06 0 0 0-.92-.83L18 37.88l.3-.82a4 4 0 0 1 5.12-2.36l2.51.91-8-13.86a2 2 0 0 1 3.46-2l4 6.93a2 2 0 0 1 3.46-2l1 1.73a2 2 0 0 1 3.47-2l1 1.73a2 2 0 1 1 3.46-2Z"
      />
      <path
        fill="#414141"
        d="M32 47a1 1 0 0 1-.84-.46l-1.3-2c-.27-.46.47 0-12.32-5.71a1 1 0 0 1-.54-1.3l.31-.82a5 5 0 0 1 6.32-3L17 22.25a3 3 0 0 1 5.2-3l2.58 4.48a3 3 0 0 1 4.39-.18 3 3 0 0 1 4.47-.27 3 3 0 0 1 5 .36l4.89 8.48c.92 1.59.66 2.86.53 4.91l.85 1.47a1 1 0 1 1-1.74 1c-.81-1.35-1.17-1.8-1.17-2.6.12-1.89.34-2.74-.26-3.78l-4.89-8.48a1 1 0 0 0-1.74 1l2 3.47a1 1 0 0 1-.36 1.36 1 1 0 0 1-1.37-.36l-3-5.2a1 1 0 0 0-.61-.46 1 1 0 0 0-1.12 1.46l3 5.2a1 1 0 0 1-1.73 1l-4-6.93a1 1 0 1 0-1.74 1c4.35 7.53 4.14 7 4.14 7.43a1 1 0 0 1-1.87.5l-8-13.86a1 1 0 0 0-1.73 1l8 13.86a1 1 0 0 1-1.21 1.44L23 35.64a3 3 0 0 0-3.81 1.7l11 4.88c1 .46 1.26 1.06 2.65 3.24A1 1 0 0 1 32 47Z"
      />
  </svg>
  )
}

export default TouchIcon